import React, { Component } from "react";
import "../Styles/SvgCommand.css";

class ValidationCommand extends Component {
  state = { canShowForm: false };
  
  render() {
    
    return (
        <svg className={"svg" + " " + this.props.className}
        width="10.000000pt" height="10.000000pt" viewBox="0 0 512.000000 512.000000"
         onClick={this.props.onClick}>
          <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)" stroke="none">
           <path d="M3172 2967 l-1542 -1542 -608 608 c-334 334 -612 607 -617 607 -6 0 -100 -90 -210 -200 l-200 -200 810 -810 c445 -446 814 -810 820 -810 6 0 794 784 1753 1743 l1742 1742 -203 203 -202 202 -1543 -1543z"/>
          </g>

        </svg>
    );

    /*<svg className="svg">
          <rect x="5" y="9" width="16" height="1.5" rx="1" />
          <rect x="12" y="2" width="1.5" height="16" rx="1" />
        </svg>
        {this.state.canShowForm && detailForm}
        */
  }
}

export default ValidationCommand;
